"use client";

import React from "react";
import AccordionItemContext from "./context";
import type {
  AccordionItemContextType,
  AccordionItemProviderProps,
} from "./types";

function AccordionItemProvider({
  isOpen,
  setIsOpen,
  children,
}: AccordionItemProviderProps) {
  const context = React.useMemo<AccordionItemContextType>(
    () => ({ isOpen, setIsOpen }),
    [isOpen, setIsOpen],
  );

  return (
    <AccordionItemContext.Provider value={context}>
      {children}
    </AccordionItemContext.Provider>
  );
}

export default AccordionItemProvider;
